import { LinkText } from '@components/LinkText';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IContratoCliente } from '@model/ContratoCliente';
import { useContratoClienteStatusColor } from '@model/ContratoClienteStatus';
import React from 'react';

export type ConferenciaChipDetalhesTableProps = {
    data: IData<IContratoCliente>
}

export function ConferenciaChipDetalhesTable ({ data }: ConferenciaChipDetalhesTableProps) {
    const formatter = useFormatter();
    const contratoClienteStatusColor = useContratoClienteStatusColor();

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Cliente</TableHeaderCell>
                    <TableHeaderCell>Empresa</TableHeaderCell>
                    <TableHeaderCell>Início</TableHeaderCell>
                    <TableHeaderCell>Valor Plano</TableHeaderCell>
                    <TableHeaderCell>Franquia GB</TableHeaderCell>
                    <TableHeaderCell>Status</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    data.items.map((contratoCliente, index) => {
                        return (
                            <TableRow>
                                <TableKeyCell>{contratoCliente.contratoClienteId}</TableKeyCell>
                                <TableCell><LinkText to={`cliente/${contratoCliente.clienteId}`} text={contratoCliente.clienteNome} /></TableCell>
                                <TableCell>{contratoCliente.linhaContratoOperadoraEmpresaNome}</TableCell>
                                <TableCell>{formatter.toDate(contratoCliente.inicio)}</TableCell>
                                <TableCell>{formatter.toFloat(contratoCliente.valorPlano)}</TableCell>
                                <TableCell>{formatter.toFloat(contratoCliente.franquiaGb)}</TableCell>
                                <TableCell className={contratoClienteStatusColor[contratoCliente.contratoClienteStatusId]}>{contratoCliente.contratoClienteStatusNome}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </TableNoResult>
    )
}